export default "__VITE_ASSET__C4Vk6eIA__"